// src/utils/bugWatch.js
// Bugs the portal catches by itself (3.83.0, owner): a page that fails to draw
// (ErrorBoundary), an error in the page, and a server error on a portal call
// (hooks/useAuth.js). Each goes to the backend (/portal/client-error →
// lib/clientErrors.js: Health → Portal errors, and a new one emails admin@).
// A lost connection, a browser add-on or a page load after a deploy aren't
// our bugs, so they aren't sent. The last few are kept for Report a bug.
import { auth, API_BASE } from '../firebase/config';
import notes from '../releaseNotes.json';

export const version = notes.releases?.[0]?.version || '';
const NOT_OURS = /ResizeObserver|^Script error|Loading (CSS )?chunk|dynamically imported module|Failed to fetch|NetworkError|Load failed|network-request-failed|AbortError|aborted|cancelled|canceled/i;
const ADD_ON = /^(chrome|moz|safari|safari-web)-extension:/;
const KEEP_MS = 10 * 60000;
const MAX_A_SESSION = 20;

const recent = [];
const sent = new Set();
export const recentErrors = () => recent.filter(e => Date.now() - e.at < KEEP_MS).map(e => e.text);

// Tell the backend about a problem in the portal (never throws)
export async function reportClientError(kind, message, extra = {}) {
  try {
    const text = String(message || '').slice(0, 300);
    if (kind !== 'bell-skip') {
      if (NOT_OURS.test(text)) return;
      recent.push({ at: Date.now(), text });
      if (recent.length > 5) recent.shift();
    }
    const key = `${kind}|${window.location.pathname}|${text}`;
    if (sent.has(key) || sent.size >= MAX_A_SESSION) return;
    sent.add(key);
    const user = auth.currentUser;
    if (!user) return;
    const token = await user.getIdToken();
    await fetch(`${API_BASE}/portal/client-error`, {
      method: 'POST', headers: { Authorization: `Bearer ${token}`, 'Content-Type': 'application/json' },
      body: JSON.stringify({ kind, message: text, page: window.location.pathname, version, ...extra }),
    });
  } catch { /* nothing to do */ }
}

// A portal call the server answered with an error (ids taken out of the address)
export function reportServerError(url, status) {
  const path = String(url).replace(API_BASE, '').split('?')[0];
  if (path.startsWith('/portal/client-error')) return;
  reportClientError('server', `Server error ${status} on ${path.replace(/[A-Za-z0-9_-]{16,}|\d{4,}/g, ':id')}`);
}

if (typeof window !== 'undefined' && !window.__faxBugWatch) {
  window.__faxBugWatch = true;
  window.addEventListener('error', e => {
    if (!e.message || ADD_ON.test(e.filename || '')) return;
    reportClientError('script', e.message, { where: `${e.filename || ''}:${e.lineno || ''}` });
  });
  window.addEventListener('unhandledrejection', e => {
    const r = e.reason;
    if (ADD_ON.test(String(r?.stack || ''))) return;
    reportClientError('script', r?.message || String(r || ''), { where: String(r?.stack || '').split('\n').slice(0, 3).join(' < ') });
  });
}
